import { CSSProperties, useEffect, useState } from "react";
import { useLoading } from "react-admin";

import useDefaultDisabledStyles from "./useDefaultDisabledStyles";

const useDisabledOnLoading = (isLoading: boolean = false) => {
  const raLoading = useLoading();
  const [loading, setLoading] = useState(false);
  const { defaultDisabledStyles } = useDefaultDisabledStyles();

  useEffect(() => {
    if (isLoading) setLoading(isLoading);
    else setLoading(raLoading);
  }, [isLoading, raLoading]);

  const disabledStyles: CSSProperties | undefined = loading ? defaultDisabledStyles : undefined;

  return { disabledStyles };
};

export default useDisabledOnLoading;
